import React, { useState, useEffect } from 'react';
import axios from 'axios';
import APP_BASE_URL from '../../components/Api/globalApi';
import VirtualMallChatView from './VirtualMallChatView';
import './VirtualMallChat.css';

export default function VirtualMallChat() {
  const [chat, setChat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const storedUserId =
    localStorage.getItem('user_id') ||
    localStorage.getItem('virtual_user_id');

  useEffect(() => {
    initAdminChat();
  }, []);

  const initAdminChat = async () => {
    setLoading(true);
    setError(null);
    try {
      // Step 1: Try to create/find the existing chat with admin (user_id=1)
      const createRes = await axios.post(
        `${APP_BASE_URL}/chat/create`,
        { recepient_id: 1 },
        { headers: { user_id: storedUserId } }
      );

      if (createRes.data.result === true) {
        const chatId = String(createRes.data.chat_id);
        setChat({
          c_id: chatId,
          c_to: 1,
          u_first_name: 'Admin',
          image: null,
        });
      } else {
        setError('Could not connect to admin chat. Please try again.');
      }
    } catch (err) {
      console.error('Error initializing admin chat:', err);
      setError('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="vm-chat-init-loader">
        <div className="vm-spinner" />
        <p>Connecting to Admin...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="vm-chat-init-error">
        <div className="vm-chat-empty-icon">⚠️</div>
        <p>{error}</p>
        <button className="vm-retry-btn" onClick={initAdminChat}>
          Retry
        </button>
      </div>
    );
  }

  if (chat) {
    return <VirtualMallChatView chat={chat} onBack={null} />;
  }

  return null;
}
